<div class="frequency-container" [ngClass]="{ 'align-start': align.toLowerCase() === 'start' }">
  <div
    [ngClass]="{
      'frequency-price': !allowCustomStyling,
      'large-frequency-price': size.toLowerCase() === 'large',
    }"
  >
    {{ value }}
  </div>
  <div class="frequency-value">
    @if (!!currencyCode) {
      <span>&nbsp;{{ currencyCode }}</span>
    }
    @if (form.toLowerCase() === Form.VERBOSE) {
      <span>&nbsp;</span>
    }
    <span>{{ frequency | glxyFrequency: form | translate }}</span>
  </div>
</div>
